import { apiAxios } from '@/api'
import { logHeardError } from './errorHelpers'

// Used when the browser's File.type is empty.
const FALLBACK_CONTENT_TYPE = 'application/octet-stream'

export const resolveUploadContentType = (file: File) =>
  file.type || FALLBACK_CONTENT_TYPE

export const getUploadSignedUrl = async (
  fileName: string,
  fileType: string
) => {
  const response = await apiAxios.get<{ signed_url: string }>(
    '/finances/api/v1/documents/get_signed_url',
    { params: { fileName, fileType } }
  )
  return response.data.signed_url
}

export const uploadFile = async (
  file: File,
  fileName: string,
  onProgress?: (percent: number) => void
) => {
  try {
    if (file.size <= 0) {
      return { error: 'File size must be larger than 0 bytes.' }
    }
    const contentType = resolveUploadContentType(file)
    const url = await getUploadSignedUrl(fileName, contentType)
    return apiAxios
      .put<string>(url, file, {
        withCredentials: false,
        headers: {
          'Content-Type': contentType,
          'x-amz-server-side-encryption': 'AES256',
        },
        // Identity transform — bypass axios's default request body
        // transformation so the File is sent as-is.
        transformRequest: [(data: File) => data],
        onUploadProgress: onProgress
          ? ({ loaded, total }) =>
              onProgress(Math.round((loaded / (total || file.size)) * 100))
          : undefined,
      })
      .then(() => null)
      .catch((err) => {
        logHeardError(err)
        return { error: 'Error uploading file.' }
      })
  } catch (err) {
    logHeardError(err)
    return { error: 'Error uploading file.' }
  }
}

// Opens a new tab with sent url
export const openFileInTab = (url: string) => {
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.target = '_blank'
  anchor.rel = 'noopener noreferrer'
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
}
